import { ComponentType, lazy } from "react";

let lazyPending = 0;

const devcertWindow = window as unknown as {
	__devcertLazyInFlight?: () => number;
};

if (import.meta.env.DEV) {
	devcertWindow.__devcertLazyInFlight = () => lazyPending;
}

export function lazyWithProbe<P extends object>(factory: () => Promise<{ default: ComponentType<P> }>) {
	return lazy(() => {
		if (!import.meta.env.DEV) return factory();

		lazyPending += 1;
		return factory().finally(() => {
			lazyPending = Math.max(0, lazyPending - 1);
		});
	});
}
